.cashfree {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}